import deepmerge from 'deepmerge'
import { ACTION_TYPES, SESSION_STATUSES } from '~/core/constants'

const { ACTIVE_SESSION } = ACTION_TYPES

const initialState = {
  details: {
    customRoomConfigs: {
      config: {
        apiLogLevels: ['warn', 'error'],
        disableBeforeUnloadHandlers: true, // JIT-9144
        screenshotCapture: {
          enabled: true,
          mode: 'recording'
        },
        prejoinConfig: {
          enabled: true
        },
        recordings: {
          suggestRecording: false
        },
        toolbarButtons: [
          'camera',
          'chat',
          'custom-panel',
          'desktop',
          'feedback',
          'filmstrip',
          'fodeviceselection',
          'hangup',
          'info',
          'invite',
          'microphone',
          'mute-everyone',
          'participants-pane',
          'profile',
          'raisehand',
          'security',
          'select-background',
          'settings',
          'shareaudio',
          'sharedvideo',
          'shortcuts',
          'stats',
          'tileview',
          'videoquality',
          'whiteboard'
        ],
        // TODO: remove after updating the 8x8.vc config
        whiteboard: {
          enabled: true
        }
      },
      interfaceConfig: {}
    }
  },
  sessionStatus: SESSION_STATUSES.CLOSED,
  startTime: null,
  waitingToJoin: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_SESSION.SET_DETAILS: {
      return {
        ...state,
        details: deepmerge(state.details, action.payload),
        sessionStatus: SESSION_STATUSES.RECEIVED_DETAILS
      }
    }
    case ACTIVE_SESSION.RESET_ACTIVE_SESSION: {
      return initialState
    }
    case ACTIVE_SESSION.SET_SESSION_STATUS: {
      let startTime = initialState.startTime

      if (action.payload === SESSION_STATUSES.CONNECTED) {
        startTime = new Date()
      }

      return {
        ...state,
        sessionStatus: action.payload,
        startTime
      }
    }
    case ACTIVE_SESSION.SET_WAITING_TO_JOIN: {
      return {
        ...state,
        waitingToJoin: action.payload
      }
    }
    case ACTIVE_SESSION.DISABLE_PREJOIN: {
      return {
        ...state,
        details: deepmerge(state.details, {
          customRoomConfigs: {
            config: {
              prejoinConfig: {
                enabled: false
              }
            }
          }
        })
      }
    }
    default:
      return state
  }
}

export default reducer
